import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { TokenResult } from '../utils/0x/token-registry.types';
import { fetcher } from '../utils/fetcher';
import { routes } from '../utils/routes';
import { objectToQueryString } from '../utils/string';

const DEFAULT_RESULT_LIMIT = 10;

interface UseTrendingTokensParams {
  chainIds?: number[];
  limit?: number;
  resolution?: '60' | '240' | '720' | '1D';
}

export const trendingTokensQueryKey = (params: {
  chainIds?: number[];
  limit: number;
  resolution: string;
}) => ['trending-tokens', params] as const;

export const useTrendingTokens = ({
  chainIds,
  limit,
  resolution = '1D',
}: UseTrendingTokensParams) => {
  const parameters = useMemo(
    () => ({
      chainIds,
      limit: limit || DEFAULT_RESULT_LIMIT,
      resolution,
    }),
    [chainIds, limit, resolution],
  );

  return useQuery<TokenResult[], Error>({
    queryKey: trendingTokensQueryKey(parameters),
    queryFn: () => fetcher(`${routes.api.TRENDING_TOKENS}${objectToQueryString(parameters)}`),
    enabled: !!chainIds && chainIds.length > 0,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
